import { Table, Tag } from "antd";
import { Key } from "antd/lib/table/interface";
import { observer } from "mobx-react";
import React from "react";

export const AuthPermissionsInput = observer(({ value = [] as any[], tree, onChange }) => {
  const selectedRowKeys = (value || []).map((x) => x.resId);

  const updateOpt = (record: any, code: string, checked: boolean) => {
    const idx = value.findIndex((v: any) => v.resId === record.code);
    const perimition = value[idx];

    const optIds = checked ? perimition.optIds.concat(code) : perimition.optIds.filter((x) => x !== code);

    const newValue = [
      ...value.slice(0, idx),
      {
        resId: perimition.resId,
        optIds,
      },
      ...value.slice(idx + 1),
    ];
    onChange(newValue);
  };

  const columns = [
    {
      title: "Page",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      key: "opt",
      render: (_, r) => {
        if (selectedRowKeys.includes(r.code)) {
          const perimition = value.find((v: any) => v.resId === r.code)!;
          return r.operations.map((it: any) => (
            <Tag.CheckableTag
              key={it.name}
              checked={perimition?.optIds?.includes(it.code)}
              onChange={(checked) => updateOpt(r, it.code, checked)}
            >
              {it.name}
            </Tag.CheckableTag>
          ));
        }
        return r.operations.map((it: any) => <Tag key={it.code}>{it.code}</Tag>);
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: Key[]) => {
      const newValue = selectedRowKeys.map((resId) => {
        const old = value.find((v) => v.resId === resId);
        return {
          resId: resId as string,
          optIds: old?.optIds || [],
        };
      });
      onChange(newValue);
    },
  };

  return (
    <Table
      className="px-24px"
      columns={columns}
      dataSource={tree}
      defaultExpandAllRows
      rowSelection={rowSelection}
      pagination={false}
      rowKey="code"
      size="small"
    ></Table>
  );
});
